export default __webpack_public_path__ + "static/media/sg5.f4fe9dd6.png";